export type ReadonlyStandardLinesEndpoints = {
  readonly GetCategoryList: string;
  readonly AddUpdateStandardLine : string;
  readonly AddUpdatePrestartTemplates : string;  
  readonly DeleteStandardLines : string;
  readonly DeletePrestartTemplates : string;
  readonly GetStandardLine : string;
  readonly GetStandardLineBySiteCategory : string;
  readonly GetStandardLineDataReArrange : string;
  readonly CheckActiveStandardLineCategory : string;
  readonly GetPrestartTemplates : string;

  readonly AddUpdateWorkTemplates : string;  
  readonly DeleteWorkTemplates : string;
  readonly GetWorkTemplates : string;


  readonly AddUpdateCompletionTemplates : string;  
  readonly DeleteCompletionTemplates : string;
  readonly GetCompletionTemplates : string;
  
  };

  const controller = 'api'
  const StandardLinesEndpoints: ReadonlyStandardLinesEndpoints = {
    GetCategoryList: `${controller}/Category`,
    //GetCategoryList: `${controller}/Category/GetCategory`,
    AddUpdateStandardLine : `${controller}/StandardLines/AddUpdateStandardLines`,
    DeleteStandardLines : `${controller}/StandardLines/DeleteStandardLines`,
    GetStandardLine : `${controller}/StandardLines/GetStandardLine`,
    GetStandardLineBySiteCategory : `${controller}/StandardLines/GetAllStandardLinesUsingSiteIdCategory`,
    GetStandardLineDataReArrange : `${controller}/StandardLines/GetStandardLineDataReArrange`, 
    CheckActiveStandardLineCategory : `${controller}/StandardLines/CheckActiveStandardLineCategory`,

    GetPrestartTemplates : `${controller}/Templates/GetPrestartTemplates`,
    AddUpdatePrestartTemplates : `${controller}/Templates/AddUpdatePrestartTemplates`,
    DeletePrestartTemplates : `${controller}/Templates/DeletePrestartTemplates`,

    GetWorkTemplates : `${controller}/Templates/GetWorkTemplates`,
    AddUpdateWorkTemplates : `${controller}/Templates/AddUpdateWorkTemplates`,
    DeleteWorkTemplates : `${controller}/Templates/DeleteWorkTemplates`,

    GetCompletionTemplates : `${controller}/Templates/GetCompletionTemplates`,
    AddUpdateCompletionTemplates : `${controller}/Templates/AddUpdateCompletionTemplates`,
    DeleteCompletionTemplates : `${controller}/Templates/DeletCompletionTemplates`,
  };
  

 
    export { StandardLinesEndpoints };